class TreeType {
  constructor () {
    this.typeMap = new Map()
  }
  use (type, url) {
    if (this.typeMap.has(type)) {
      console.error('this url only use once')
      return
    }
    this.typeMap.set(type, url)
  }
  getGroup (type) {
    return this.typeMap.get(type)
  }
  static getQueryParams ({ rootId, title, pageSize, currentPage, scope, disabledIds }) {
    return {
      rootId,
      title,
      pageSize,
      currentPage,
      scope,
      disabledIds,
      bizLineCode: this.bizLineCode || 'YWX01'
    }
  }
  static getListParams ({ rootId, showRoot, level, selectId, disabledOrgCategorys, scope, disabledIds, bizLineCode }) {
    return {
      rootId,
      showRoot,
      level,
      selectId,
      disabledOrgCategorys,
      scope,
      disabledIds,
      bizLineCode: bizLineCode
    }
  }
  static getLazyParams ({ startId, id, disabledOrgCategorys, scope, disabledIds }) {
    return {
      startId,
      id,
      scope,
      disabledOrgCategorys,
      disabledIds,
      bizLineCode: this.bizLineCode || 'YWX01'
    }
  }
}
const treeType = new TreeType()
treeType.use('single-organize-life-hr', {
  list: 'tree/secret/hr/single/getTree',
  query: 'tree/secret/hr/single/searchTree',
  lazy: 'tree/secret/hr/single/getDetail'
})
// Single Choice Whole Tree
treeType.use('single-organize-life', {
  list: 'api-general/module/portal/singleTree/getTree',
  query: 'tree/secret/single/searchTree',
  lazy: 'tree/secret/single/getDetail'
})
// Single Choice Whole Tree
treeType.use('single-all', {
  list: 'api-general/module/portal/singleTree/getTree',
  query: 'tree/singleTree/searchTree',
  lazy: 'tree/singleTree/getDetail'
})
// Multiple Choice Whole Tree
treeType.use('secret-multiple-all', {
  list: 'tree/secret/multiple/getTree',
  query: 'tree/secret/multiple/searchTree',
  lazy: 'tree/secret/multiple/getDetail'
})
// Multiple Choice Whole Tree
treeType.use('multiple-all', {
  list: 'tree/multipleTree/getTree',
  query: 'tree/multipleTree/searchTree',
  lazy: 'tree/multipleTree/getDetail'
})
// Multiple Choice Whole Tree
treeType.use('map-multiple-all', {
  list: 'orgMapExpand/getTree',
  query: 'orgMapExpand/searchTree',
  lazy: 'orgMapExpand/getDetail'
})
// Single Choice Plan Tree
treeType.use('single-plan', {
  list: 'pmdPlan/getTree',
  query: 'pmdPlan/searchTree',
  lazy: 'pmdPlan/getDetail'
})
// Single Choice relation Tree
treeType.use('target-relation', {
  list: 'module/transfer/target/tree/getTree',
  query: 'module/transfer/target/tree/searchTree',
  lazy: 'module/transfer/target/tree/getDetail'
})
// Single Choice relation Tree
treeType.use('single-relation', {
  list: 'module/transfer/tree/getTree',
  query: 'module/transfer/tree/searchTree',
  lazy: 'module/transfer/tree/getDetail'
})
// Single Choice relation Tree
treeType.use('floatlog-partymember', {
  list: 'module/partymemberfloatlog/tree/getTree',
  query: 'module/partymemberfloatlog/tree/searchTree',
  lazy: 'module/partymemberfloatlog/tree/getDetail'
})
// 支部变动
treeType.use('branch-change', {
  list: 'pmd/orgchange/tree/getTree',
  query: 'pmd/orgchange/tree/searchTree',
  lazy: 'pmd/orgchange/tree/getDetail'
})
treeType.use('async-change', {
  list: 'api-uum/uum/org/tree/single/getTree',
  query: 'api-uum/uum/org/tree/single/searchTree',
  lazy: 'api-uum/uum/org/tree/single/getDetail'
})
export {
  treeType,
  TreeType
}
